import React from 'react';
import { DEFAULT_TERMINAL_WIDTH } from '../../constants';
import { BaseTool } from './BaseTool';
import type { ToolComponentProps, NotifyMeWhenInput } from './types';

// The wake message is not shown here: it is the note the agent leaves for its
// future self, and the user reads it on the card of the check-in that fired.
export const NotifyMeWhenTool: React.FC<ToolComponentProps<NotifyMeWhenInput>> = ({
  input,
  state,
  expanded,
  columns = DEFAULT_TERMINAL_WIDTH,
}) => (
  <BaseTool
    label={`Schedule check-in in ${input.delayMinutes} minute${input.delayMinutes === 1 ? '' : 's'}`}
    state={state}
    expanded={expanded}
    columns={columns}
  />
);
